module.exports = __webpack_public_path__ + "static/img/ikonaZdjecie-OFF.8bf3c614.png";